<template>
  <HandyScroll class="handscrolls v-data-table table-layout pa-4 pt-0 theme--light" ref="handscrolls">
    <!-- <v-simple-table class="table-layout pa-4 pt-0"> -->
      <!-- <template v-slot:default> -->
        <thead>
          <tr>
            <th>STT</th>
            <th v-if="typeTable == 'order'">Ngày tạo</th>
            <th v-if="typeTable == 'receipt'">Ngày tạo phiếu</th>
            <th v-if="typeTable == 'receipt'">Mã phiếu thu</th>
            <th v-if="typeTable == 'receipt'">Trạng thái phiếu</th>
            <th v-if="typeTable == 'receipt'">Người tạo phiếu</th>
            <th v-if="typeTable == 'receipt'">Giá trị phiếu (đ)</th>
            <th>Mã ĐH</th>
            <th>Loại đơn</th>
            <th>Trạng thái</th>
            <th>{{typeTable == 'receipt' ? 'Người nhận hàng' : 'Tên khách hàng'}}</th>
            <th>Địa chỉ</th>
            <th>Phường(Xã)</th>
            <th>Quận(Huyện)</th>
            <th>Tỉnh(TP)</th>
            <!-- <th>Giá trị ĐH</th> -->
            <!-- <th>Chiết khấu</th> -->
            <!-- <th>Đã thanh toán</th> -->
            <th v-if="typeTable == 'order'">Giá trị đơn</th>
            <th v-if="typeTable == 'order'">Doanh thu khởi tạo</th>
            <!-- <th>Doanh thu</th> -->
            <th v-if="typeTable == 'order'">Người thực hiện</th>
            <th v-if="checkAuthorization('order_update')">Thao tác</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(order, index) in orders" :key="order.id">
            <td>{{(currentPage * 10 - 10) + (index + 1)}}</td>
            <td v-if="typeTable == 'order'">{{formatDate(order.createdAt)}}</td>
            <td v-if="typeTable == 'receipt'">{{formatDate(order.receipt.createdAt)}}</td>
            <td v-if="typeTable == 'receipt'">{{order.receipt.code}}</td>
            <td v-if="typeTable == 'receipt'">{{statusReceipt[`${order.receipt.status}`]}}</td>
            <td v-if="typeTable == 'receipt'">{{order.receipt.createdByName}}</td>
            <td v-if="typeTable == 'receipt'">{{formatPrice(order.receipt.amount)}}</td>
            <td v-if="typeTable == 'order'">
              <v-tooltip bottom v-if="checkAuthorization('order_read')">
                <template v-slot:activator="{ on }">
                  <span v-on="on" @click="clickDetailOrder(order.id)" class="btn-detail">
                    {{order.code}}
                  </span>
                </template>
                <span>Xem chi tiết thông tin đơn hàng</span>
              </v-tooltip>
              <span v-else>{{_.get(order, 'receiver', '')}}</span>
            </td>
            <td v-if="typeTable == 'receipt'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" @click="checkAuthorization('order_read') ? clickDetailOrder(order.order.id) : ''" class="btn-detail">
                    {{order.order.code}}
                  </span>
                </template>
                <span>Xem chi tiết thông tin đơn hàng</span>
              </v-tooltip>
            </td>
            <td v-if="typeTable == 'receipt'">{{order.order.metadata.version === 1 ? "v1" : "v2"}} {{order.order.metadata.orderPurchaseType ? ` - ${order.order.metadata.orderPurchaseType}` : ''}}</td>
            <td v-if="typeTable == 'order'">{{order.version === 1 ? "v1" : "v2"}}</td>
            <td v-if="typeTable == 'order'">{{dataStatus(_.get(order, 'contactStatus', {}))}}</td>
            <td v-if="typeTable == 'receipt'">{{dataStatus(_.get(order.order, 'contactStatus', {}))}}</td>
            <td v-if="typeTable == 'order'">
              <v-tooltip bottom v-if="checkAuthorization('order_update')">
                <template v-slot:activator="{ on }">
                  <span v-on="on" @click="clickDetailCustomer(order.contactId)" class="btn-detail">
                    {{_.get(order, 'receiver', '')}}
                  </span>
                </template>
                <span>Xem chi tiết thông tin khách hàng</span>
              </v-tooltip>
              <span v-else>{{_.get(order, 'receiver', '')}}</span>
            </td>
            <td v-if="typeTable == 'receipt'">
              {{order.receiptShippingAddress.receiver}}
            </td>
            <td>{{typeTable == 'order' ? order.detailAddress : order.receiptShippingAddress.addressDetail}}</td>
            <td>{{typeTable == 'order' ? _.get(order, 'ward.ten', '') : _.get(order, 'receiptShippingAddress.ward.ten', '') }}</td>
            <td>{{typeTable == 'order' ? _.get(order, 'district.ten', '') : _.get(order, 'receiptShippingAddress.district.ten', '')}}</td>
            <td>{{typeTable == 'order' ? _.get(order, 'province.ten', '') : _.get(order, 'receiptShippingAddress.province.ten', '')}}</td>
            <!-- <td>{{formatPrice(order.totalPrice)}}</td> -->
            <!-- <td>{{formatPrice(0)}}</td> -->
            <!-- <td>{{formatPrice(_.get(order, 'paidAmount', 0))}}</td> -->
            <td v-if="typeTable == 'order'">{{formatPrice(order.totalPrice)}}</td>
            <td v-if="typeTable == 'order'">{{ order.initTurnOver ? formatPrice(order.initTurnOver) : 0 }}</td>
            <!-- <td>{{formatPrice(order.totalPrice)}}</td> -->
            <td v-if="typeTable == 'order'">{{_.get(order, 'user.fullName', '')}}</td>
            <td v-if="checkAuthorization('order_update')">
              <div class="action">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="typeTable == 'order' ? clickDetailOrder(order.id) : clickDetailOrder(order.order.id)"
                      class="mr-2"
                      icon
                      small
                      color="primary"
                      v-on="on"
                    >
                      <v-icon>mdi-file-document</v-icon>
                    </v-btn>
                  </template>
                  <span>Xem chi tiết thông tin đơn hàng</span>
                </v-tooltip>
              </div>
            </td>
          </tr>
        </tbody>
      <!-- </template> -->
    <!-- </v-simple-table> -->
  </HandyScroll>
</template>
<script>
import HandyScroll, {EventBus} from "vue-handy-scroll"
export default {
  components: {
    HandyScroll
  },
  props: {
    orders: {
      type: Array,
      default: () => []
    },
    typeTable: {
      type: String,
      default: 'order'
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      statusReceipt: {
        init: 'Chờ xử lý',
        in_progress: 'Chờ thanh toán',
        final_success: 'Thành công',
        final_return: 'Hoàn',
        final_cancel: 'Hủy',
        final_failed: 'Thất bại',
      },
    }
  },
  mounted() {
    EventBus.$emit("update", this.$refs.handscrolls.$el)
  },
  updated() {
    EventBus.$emit("update", this.$refs.handscrolls.$el)
  },
  methods: {
    clickDetailOrder(orderId) {
      // this.$router.push({
      let route = this.$router.resolve({
        name: 'OrderDetail',
        params: {
          id: orderId,
        },
        query: {
          orderList: true,
        },
      });
      window.open(route.href, '_blank')
    },
    clickDetailCustomer(CustomerId) {
      let route = this.$router.resolve({
        name: 'ContactDetail',
        params: {
          id: CustomerId,
        },
      });
      window.open(route.href, '_blank')
    },
    dataStatus(contactStatus) {
      return `${_.get(contactStatus, 'type', '')}-${_.get(
        contactStatus,
        'name',
        ''
      )}`;
    },
  }
};
</script>

<style lang="css" scoped>
  .handscrolls {
    height: calc(100vh - 310px);
    overflow: auto;
  }
  .btn-detail {
    font-weight: 500;
    cursor: pointer;
  }
</style>
